import { render, staticRenderFns } from "./CreateType.vue?vue&type=template&id=6dc558c1&scoped=true&"
import script from "./CreateType.vue?vue&type=script&lang=js&"
export * from "./CreateType.vue?vue&type=script&lang=js&"
import style0 from "./CreateType.vue?vue&type=style&index=0&id=6dc558c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc558c1",
  null
  
)

export default component.exports